import type React from "react";
import "./style.css";
import { useSearchParams } from "react-router";
import { TermsEnglish } from "~/pages/Terms/TermsEnglish";
import { TermsJapanese } from "~/pages/Terms/TermsJapanese";

export const Terms: React.FC = () => {
	const [searchParams] = useSearchParams();
	const lang = searchParams.get("lang") ?? "en";
	if (lang === "ja") {
		return <TermsJapanese />;
	}
	return <TermsEnglish />;
};
